export async function optimisticallyUpdate<T, PT>({
  persistData,
  writeDataToCache,
  optimisticData,
  revertData,
}: {
  persistData: (onCancel?: () => void) => Promise<PT>;
  writeDataToCache: (data: T) => void;
  optimisticData: T;
  revertData: T;
}): Promise<PT> {
  writeDataToCache(optimisticData);
  try {
    return await persistData(() => {
      writeDataToCache(revertData);
    });
  } catch (e) {
    writeDataToCache(revertData);
    throw e;
  }
}
